var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex mt-2" }, [
    _c(
      "div",
      { staticClass: "align-stretch" },
      [
        _c("v-skeleton-loader", {
          staticClass: "bgPanel rounded-md",
          attrs: {
            type: "image, article",
            width: "400",
            "min-height": "calc(100% - 155px)",
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "flex-grow-1 ml-10" },
      _vm._l(3, function (item) {
        return _c(
          "div",
          { key: item, staticClass: "d-block" },
          [
            _c("v-skeleton-loader", {
              staticClass: "mb-2 panel px-1 rounded-md",
              attrs: { transition: "fade-transition", type: "image" },
            }),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }